<template lang="pug">
v-btn.btn(
  v-bind="extendedAttrs"
  v-on="$listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(
      :name="name"
      v-bind="data"
    )
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
  template(v-if="label")
    | {{ label }}
</template>

<script>
export const STYLE_TYPE = {
  default: 0,
  text: 1,
  icon: 2,
};

export default {
  name: 'AppButton',
  props: {
    styleType: {
      type: Number,
      default: STYLE_TYPE.default,
    },
    size: {
      // if @styleType === `icon` then set width & height, else set height
      type: [Number, String],
      default: null,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    breakContent: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    extendedAttrs() {
      const { $attrs, $props, outlined, breakContent, styleTypeData, sizes } = this;
      const currentStyles = {
        ...styleTypeData,
        ...sizes,
        outlined,
        class: [
          ...(styleTypeData.class || []),
          ...(outlined ? ['btn--white'] : []),
          ...(breakContent ? ['btn--break-content'] : []),
        ],
      };
      return {
        ...currentStyles,
        ...$props,
        ...$attrs,
      };
    },
    styleTypeData() {
      const { styleType } = this;
      return {
        [STYLE_TYPE.default]: {
          color: 'redesignPrimary',
        },
        [STYLE_TYPE.text]: {
          height: 24,
          opacity: 1,
          text: true,
          ripple: false,
          color: 'transparent',
          class: ['body-1', 'pa-0', 'fit-content-width', 'redesignPrimaryDarken--text', 'weight-500', 'rounded-12', 'no-before', 'type--text'],
        },
        [STYLE_TYPE.icon]: {
          height: 40,
          width: 40,
          'min-width': 40,
          color: 'redesignBackground',
          class: ['rounded-12'],
        },
      }[styleType];
    },
    sizes() {
      const { styleType, size } = this;
      if (!size) return {};
      switch (styleType) {
        case STYLE_TYPE.icon:
          return {
            'min-width': size,
            'max-width': size,
            width: size,
            'min-height': size,
            'max-height': size,
            height: size,
          };
        default:
          return {
            'min-height': size,
            'max-height': size,
            height: size,
          };
      }
    },
  },
};
</script>

<style scoped lang="scss">
.btn {
  &--white {
    background-color: #{$redesignControlsBackground} !important;
  }
  &--break-content {
    overflow: hidden;
    &::v-deep .v-btn__content {
      overflow: hidden;
      width: 100%;
      flex-wrap: wrap;
      word-break: break-word;
    }
  }
}
::v-deep.v-btn {
  color: #{$redesignControlsBackground};
  font-size: 16px;
  font-weight: 500;
  height: 40px;

  &--disabled:not(.btn--white):not(.type--text) {
    // color: #{$redesignControlsBackground} !important;
    border-radius: 12px;
  }

  &--rounded {
    border-radius: 12px;
  }

  &--text {
    border-radius: 12px;
  }

  &--icon {
    width: 40px;

    &.v-size {
      &--small {
        width: 28px;
        height: 28px;
      }

      &--x-small {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
